import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface ClearFiltersProps {
  amountOfActiveFilters: number;
  onClearFilters: () => void;
}

const ClearFilters: FC<ClearFiltersProps> = ({
  amountOfActiveFilters,
  onClearFilters,
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-row gap-1 items-center'>
      <span className='text-sm text-muted-foreground'>
        {amountOfActiveFilters > 0
          ? t('blocks.dataTable.clearFilters.activeFilters', {
              count: amountOfActiveFilters,
            })
          : t('blocks.dataTable.clearFilters.noActiveFilters')}
      </span>
      <Button
        variant='link'
        size='sm'
        onClick={onClearFilters}>
        {t('blocks.dataTable.clearFilters.clearFilters')}
      </Button>
    </div>
  );
};

export default ClearFilters;
